import React from "react";
import CrossButton from "../../CrossButton/CrossButton";
import { REPORT_EXPORT_TYPES } from "../../../../constants";
import useExportFileTypePopupData from "./useExportFileTypePopupData";

const ExportFileTypePopup = ({ popupData, closePopup }) => {
  const { handleOptionClick } = useExportFileTypePopupData({
    popupData,
    closePopup,
  });

  return (
    <div className="w-48 bg-white z-50 border border-gray-light rounded-md shadow-lg">
      <div className="flex flex-row justify-end px-4 pt-4">
        <CrossButton onClick={closePopup} />
      </div>

      <div className="px-4 pb-4">
        <span className="text-base font-bold">Download</span>
      </div>

      <ul>
        {REPORT_EXPORT_TYPES.map((option) => (
          <button
            key={option.label}
            type="button"
            className="p-4 flex w-full cursor-pointer transition-colors duration-300 ease-in-out hover:bg-inputBgGreen"
            onClick={(event) => handleOptionClick(event, option)}
          >
            {option.label}
          </button>
        ))}
      </ul>
    </div>
  );
};

export default ExportFileTypePopup;
